<template lang="pug">
  div.app-image-preview
    el-image(
      v-if="src"
      ref="previewImage"
      style="max-width:100%; max-height:100%; position:absolute; top:50px"
      :preview-src-list="[src]"
      :src="src"
    )
</template>

<script>
export default {
  name: 'AppImagePreview',

  props: {
    src: {
      type: String,
      default: null
    }
  },

  mounted () {
    this.ensureWhitePreviewBg()
  },

  beforeDestroy () {
    const node = document.getElementById('app-image-preview-viewer-style')
    if (node) node.remove()
  },

  methods: {
    ensureWhitePreviewBg () {
      if (document.getElementById('app-image-preview-viewer-style')) return
      const style = document.createElement('style')
      style.id = 'app-image-preview-viewer-style'
      style.textContent = `
        .el-image-viewer__wrapper {
          background: #fff !important;
          overflow: visible !important;
          z-index: 2000 !important;
          position: absolute !important;
        }
        .el-image-viewer__mask { background: #fff !important; }
        .el-image-viewer__btn { color: #000 !important; }
        .el-image-viewer__actions {
          z-index: 2010 !important;
          pointer-events: auto !important;
          bottom: 50px !important;
          box-shadow: 0 2px 12px rgba(0,0,0,0.15);
        }
        .el-image-viewer__prev,
        .el-image-viewer__next,
        .el-image-viewer__close {
          z-index: 2010 !important;
        }
        .el-image-viewer__close {
          display: none !important;
        }
      `
      document.head.appendChild(style)
    },

    patchClose () {
      const el = this.$refs.previewImage
      if (!el?.closeViewer) return
      const original = el.closeViewer.bind(el)
      el.closeViewer = (...args) => {
        this.$emit('close')
        return original(...args)
      }
    },

    showPreview () {
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.previewImage) {
            this.$refs.previewImage.showViewer = true
            this.patchClose()
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppImagePreview.vue